import {
  Component,
  EventEmitter,
  Input,
  OnDestroy,
  OnInit,
  Output,
} from "@angular/core";
import { MatSnackBar } from "@angular/material";
import { Observable } from "rxjs";
import { CodeTable } from "src/app/core/model/v2/code-table";
import { UserSetup } from "src/app/core/model/v2/practitioner/UserSetup";
import { GlobalDataService } from "src/app/core/services/v2/global-data.service";
import { WindowLoaderService } from "src/app/shared/components/window-loader/window-loader.service";
import { Address } from "../../../../core/model/v2/practice/address";
import { HealthSystemSetup } from "../../../../core/model/v2/practice/HealthSystemSetup";
import { Practitioner } from "../../../../core/model/v2/practitioner/practitioner";
import { PracticeService } from "../../../../core/services/v2/practice.service";
import { SetupService } from "../../setup.service";
import { PractitionerSetupBase } from "../Shared/PractitionerSetupBase";

@Component({
  selector: "app-physician-assistant",
  templateUrl: "../Shared/practitionerSetup.component.html",
  styleUrls: ["../Shared/practitionerSetup.component.scss"],
})
export class PhysicianAssistantComponent
  extends PractitionerSetupBase
  implements OnInit
{
  onSearchSuccess(): void {}

  onSaveSuccess(): void {
    this.save.emit();
  }
  @Input() selectedHealthSystem: number;
  @Input() isSidebarOpened: boolean = false;
  @Output() isSidebarOpenedChange = new EventEmitter<boolean>();
  @Input() availableHealthSystems: HealthSystemSetup[];
  @Input() states: CodeTable;
  @Output() save = new EventEmitter();
  @Input() availableRoles: string[];

  constructor(
    private _setupService: SetupService,
    private _practiceService: PracticeService,
    private _loaderService: WindowLoaderService,
    private _matSnackBar: MatSnackBar
  ) {
    super(
      "Medical Professional",
      _practiceService,
      _loaderService,
      _matSnackBar
    );
  }

  ngOnInit() {
    this._setupService.editPhysicianAssistant$.subscribe(
      (userSetup) => {
        this.npi = userSetup.practitioner.npi;
        this.setPractitionerToEdit(userSetup);
      },
      (error) => {
        console.error(error);
      }
    );
  }
}
